import { getAPICall, postAPICall } from './BaseAPI';

export const createReservation = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/createreservation', payload, cb);
};

export const getReservationsData = (searchOptions, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/getreservationsdata/',searchOptions, cb);
}

export const getAbandonedCartsData = (searchOptions, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/getabandonedcartsdata/',searchOptions, cb);
}

export const getReservationsCounts = (searchOptions, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/getreservationscounts/',searchOptions, cb);
}

export const getPmcReportData = (searchOptions, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/getpmcreportdata',searchOptions, cb);
}

export const getPmcReportFilters = (cb=(jR, s, e)=>{}) => {
  getAPICall('reservations/getpmcreportfilters', cb);
}

export const getReservationDetail = async (id, cb=(jR, s, e)=>{}) => {
  return await getAPICall('reservations/getreservationdetails/' + id, cb);
}

export const updateReservation = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/updatereservation', payload, cb);
};

export const updateReservationItem = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/updatereservationitem', payload, cb);
};

export const updateReservationItems = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/updatereservationitems', payload, cb);
};

export const deleteReservationItem = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/removereservationitem', payload, cb);
};

export const createTransaction = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/createtransaction', payload, cb);
};

export const  getTransactionsData = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/gettransactionsdata/', payload, cb);
}

export const  getPhotosData = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/getreservationphotos/', payload, cb);
}

export const scanBarcode = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('reservations/scanbarcode/', payload, cb);
}

export const quickScan = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('reservations/quickscan/', payload, cb);
}

export const checkedInBarcode = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('reservations/checkedinbarcode/', payload, cb);
}

export const findReservationByBarcode = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('reservations/findbybarcode/', payload, cb);
}

export const getAvaliableSheet = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('reservations/getavailablesheet/', payload, cb);
}

export const sendOrderBackupEmail = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('reservations/sendbackupemail/', payload, cb);
}

export const getBackupNotification = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('reservations/getbackupnotification/', payload, cb);
}

export const sendSMS = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('reservations/sendsms/', payload, cb);
}

export const sendEmail = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('reservations/sendemail/', payload, cb);
}

export const getTwilioMessage = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('reservations/getreservationtwilioMessages/', payload, cb);
}

export const getEmailLogs = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('email-logs/getemaillogsdata', payload, cb);
}

export const getEmailLogById = async (id, cb = (jR, s, e)=>{}) => {
  return await getAPICall('email-logs/' + id, cb);
}

export const retryEmailLog = async (id, cb = (jR, s, e)=>{}) => {
  return await postAPICall('email-logs/' + id + '/retry', {}, cb);
}

export const getBillingSummeryData = (searchOptions, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/getbillingsummarydata/',searchOptions, cb);
}

export const updateReservationManualAddress = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('reservations/updatereservationmanualaddress', payload, cb);
};

export const getReservationsWithManualAddressData = (searchOptions, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/getreservationswithmanualaddressdata/',searchOptions, cb);
}

export const getReservationHistoryData = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/getreservationhistory/',payload, cb);
}

export const getReservationDocsData = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/getreservationdocsdata/',payload, cb);
}

export const getBusyPeriods = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reservations/getbusyperiods/', payload, cb);
}